export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const ON_SUBMIT_TRUE = 'boilerplate/UploadPage/ON_SUBMIT_TRUE';
export const SET_PROCESS_COUNT = 'boilerplate/UploadPage/SET_PROCESS_COUNT';
export const SET_ERR_COUNT = 'boilderplate/UploadPage/SET_ERR_COUNT';
export const LOADER_STATUS = 'boilderplate/UploadPage/LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/UploadPage/PROFILE_INFO';
export const SUPPLIER_INFO = 'boilerplate/UploadPage/SUPPLIER_INFO';
export const SET_TOTAL_RECORD = 'boilerplate/GSTR7_UploadPage/SET_TOTAL_RECORD'
export const SET_TABLE_DATA = 'gstr7/SET_TABLE_DATA';
export const SET_ENTITY_LIST = 'gstr7/SET_ENTITY_LIST';
export const SET_SELECTED_ENTITY = 'gstr7/SET_SELECTED_ENTITY';